import gql from 'graphql-tag';

export default gql`
  mutation moveFilesAndFoldersMutation($items: [MoveItemInput!]!, $targetFolderId: ID!) {
    moveFilesAndFoldersMutation(items: $items, targetFolderId: $targetFolderId) {
      movedCount
      conflicts
      errors
    }
  }
`;
